import React from "react";
import {
    SquaresFour, FirstAidKit, Factory, ChatCircle,
} from "@phosphor-icons/react";

export const TABS = [
    { key: "overview",    label: "Overview",    Icon: SquaresFour },
    { key: "treatment",   label: "Treatment",   Icon: FirstAidKit },
    { key: "fulfillment", label: "Fulfillment", Icon: Factory },
    // iter101.93 · Ops tab retired. Every admin-owned assignment
    // (Planner / QA / Compliance Coach / Production Tech / Priority /
    // Target Date) now lives in the Overview right rail so admin has
    // ONE canonical view per record, mirroring Linear / HubSpot /
    // Salesforce case-detail conventions.
    { key: "activity",    label: "Activity",    Icon: ChatCircle },
];

/**
 * Admin case-detail tab strip.
 *
 * iter101.11 · Phase 1 of the Universal Case Page migration — swapped
 * the filled-pill active style for the doctor-portal's underline pattern
 * so both portals share the same tab grammar. Icons + labels + a
 * per-tab red dot / numeric badge are preserved.
 */
export function CaseTabsNav({ active, onChange, badges = {}, dots = {} }) {
    return (
        <div className="mt-4 flex items-center gap-1 border-b border-border overflow-x-auto" data-testid="case-tabs-nav">
            {TABS.map((t) => {
                const isActive = active === t.key;
                const Icon = t.Icon;
                const badge = badges[t.key];
                const dot = dots[t.key];
                return (
                    <button
                        key={t.key}
                        type="button"
                        onClick={() => onChange(t.key)}
                        className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors flex items-center gap-1.5 ${
                            isActive
                                ? "border-primary text-primary"
                                : "border-transparent text-muted-foreground hover:text-foreground"
                        }`}
                        data-testid={`case-tab-${t.key}${isActive ? "-active" : ""}`}
                    >
                        <Icon size={14} weight={isActive ? "fill" : "duotone"} />
                        {t.label}
                        {dot && (
                            <span
                                className="ml-0.5 w-2 h-2 rounded-full bg-rose-500 animate-pulse"
                                data-testid={`case-tab-${t.key}-dot`}
                                title="Needs your attention"
                            />
                        )}
                        {!dot && typeof badge === "number" && badge > 0 && (
                            <span className="ml-0.5 text-[10px] font-bold rounded-full px-1.5 py-0.5 tabular-nums bg-secondary text-muted-foreground">
                                {badge}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
